import { LoadableLazy } from '@confluence/loadable';

export const PageCatchupComponent = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-PageCatchupComponent" */ '../src/PageCatchupStreaming/PageCatchupStreamingEntryPoint.tsx'
			)
		).PageCatchupComponentWithErrorBoundary,
});
